import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { initTheme } from './app/core/theme';

initTheme(); // stored theme before first paint - no flash of the wrong theme

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
